import type { ReactNode } from 'react';
import { v } from '@/theme/tokens';

export type BadgeTone = 'neutral' | 'accent' | 'positive' | 'negative' | 'warning';

const TONES: Record<BadgeTone, { bg: string; fg: string }> = {
  neutral: { bg: v('line-soft'), fg: v('ink-sub') },
  accent: { bg: v('accent-soft'), fg: v('accent-ink') },
  positive: { bg: v('positive-soft'), fg: v('positive') },
  negative: { bg: v('negative-soft'), fg: v('negative') },
  warning: { bg: v('warning-soft'), fg: v('warning') },
};

export function Badge({ children, tone = 'neutral' }: { children: ReactNode; tone?: BadgeTone }) {
  const { bg, fg } = TONES[tone];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        background: bg,
        color: fg,
        fontSize: 12,
        fontWeight: 600,
        padding: '3px 9px',
        borderRadius: 999,
        whiteSpace: 'nowrap',
      }}
    >
      {children}
    </span>
  );
}
